import { T_ADULT_WELCOME_POPUP_PAGE_CONSTANTS } from './TYPES'

const DE_ADULT_WELCOME_POPUP_PAGE_CONSTANTS: T_ADULT_WELCOME_POPUP_PAGE_CONSTANTS =
  {
    TITLE: 'Willkommen bei GriffyReads!',
    KICKER: 'Bevor Ihr Kind mit dem Lesen beginnen kann...',
    BODY: 'GriffyReads wurde für Kinder entwickelt. Um auf Quizze, Lesewettbewerbe und Events zuzugreifen, benötigt Ihr Kind ein eigenes Konto, das Sie in weniger als einer Minute erstellen können.',
    STEP_1_TITLE: '1. Kinderkonto erstellen',
    STEP_1_BODY:
      'Fügen Sie das Profil Ihres Kindes in wenigen einfachen Schritten hinzu.',
    STEP_2_TITLE: '2. Kind meldet sich an',
    STEP_2_BODY:
      'Das Kind verwendet sein eigenes Konto, um GriffyReads zu betreten und Quizze zu lösen.',
    STEP_3_TITLE: '3. Lesen, Spielen & Wachsen',
    STEP_3_BODY:
      'Sie können Quizze lösen, Punkte sammeln und an Lesewettbewerbe und Events teilnehmen!',
    PRIMARY_CTA: 'Kinderkonto erstellen',
    SECONDARY_CTA: 'Vielleicht später',
    FOOTER:
      'Erwachsenenkonten sind kostenlos. Kinder können selbst kein Konto erstellen.'
  }

export default DE_ADULT_WELCOME_POPUP_PAGE_CONSTANTS
